"use client";
import { useState } from "react";
import { FiltersData } from "./constants";
import { GlowButton } from "../ui/button/GlowButton";

export default function MemeCoinsFilter({
  onFilterChange,
  sortBy,
}: {
  onFilterChange: (filter: string) => void;
  sortBy: "createdAt" | "marketCap" | "degen" | "builder" | "trending" | string;
}) {
  const [optimisticUpdate, setOptimisticUpdate] = useState("createdAt");

  const instantFeedBack = (filter: string) => {
    setOptimisticUpdate(filter);
  };

  const sortValue = optimisticUpdate ?? sortBy;

  return (
    <div className="flex lg:flex-row lg:justify-between items-center flex-col gap-4 mb-6">
      <div className="overflow-x-auto max-w-full md:overflow-visible scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-700 scrollbar-thumb-rounded-full">
        <div className="flex gap-[10px] pb-2 ">
          {FiltersData.map((filter) => (
            <GlowButton
              key={filter.id}
              onClick={() => {
                onFilterChange(filter.id);
                instantFeedBack(filter.id);
              }}
              variant={
                sortValue === filter.id
                  ? (filter.selectedGlow as
                      | "glowRed"
                      | "glowBlue"
                      | "glowGreen"
                      | "glowPurple"
                      | "default")
                  : "default"
              }
              className="flex items-center justify-center gap-[6px] w-full max-w-fit"
            >
              {filter.icon}
              {filter.title}
            </GlowButton>
          ))}
        </div>
      </div>
    </div>
  );
}
